var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Divider, InputAdornment, InputLabel, Typography } from '@mui/material';
import { blue } from '@mui/material/colors';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { APPLICATION_SETTINGS, sentOtpUrl, verifyOtpUrl } from '../../../api/url';
import { GreenVerifiedTick } from '../../../assets/images';
import { InputBox, MuiButton, MuiStack, MuiUseForm } from '../../../components';
import { DEFAULT_MOB_NO_REGEX, LOCAL_STORAGE_KEYS, LoginOtpTimer } from '../../../constants';
import { showLoader, showNotification } from '../../../redux/commonSlice';
import { getListAPI, setReducerState } from '../../../redux/crudSlice';
import { useAppDispatch } from '../../../store/hooks';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { formatTime, GoogleAnlyticsErrorLog, handleServerSideErrors, handleServerSideErrorsForAnalytics } from '../../../utils/utils';
import { REG, validateContactNumber } from '../../../utils/validationHelper';
export var VerifyMobile = function (props) {
    var _JSON$parse, _values$MobileNumber, _values$MobileNumber2;
    var Primary = props.Primary, Alternate = props.Alternate, isAlternateNumber = props.isAlternateNumber, onMobileNumberChange = props.onMobileNumberChange, onAlternateMobileNumberChange = props.onAlternateMobileNumberChange, disabled = props.disabled, verficationTickPrimary = props.verficationTickPrimary, setVerificationTickPrimary = props.setVerificationTickPrimary, verficationTickAlternate = props.verficationTickAlternate, setVerificationTickAlternate = props.setVerificationTickAlternate, vehicleDetail = props.vehicleDetail, setValidationMessage = props.setValidationMessage;
    var applicationSetting = localStorage.getItem(APPLICATION_SETTINGS);
    var otpLength = applicationSetting ? JSON.parse(applicationSetting !== null && applicationSetting !== void 0 ? applicationSetting : "").data.OTPLength : 4;
    var initialValues = {
        MobileNumber: Primary || Alternate || ""
    };
    var _a = useState(false), isCounterActive = _a[0], setIsCounterActive = _a[1];
    var _b = useState(false), isRiderVerified = _b[0], setIsRiderVerified = _b[1];
    var _c = useState(verficationTickPrimary !== null && verficationTickPrimary !== void 0 ? verficationTickPrimary : false), isPrimaryDisable = _c[0], setPrimaryDisable = _c[1];
    var timerCount = applicationSetting ? Number((_JSON$parse = JSON.parse(applicationSetting !== null && applicationSetting !== void 0 ? applicationSetting : "")) === null || _JSON$parse === void 0 || (_JSON$parse = _JSON$parse.data) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.OTPExpireTime) : LoginOtpTimer;
    var _d = useState(timerCount), counter = _d[0], setCounter = _d[1];
    var _e = useState(false), sendOTP = _e[0], setSendOTP = _e[1];
    var _f = useState(false), verifyOtp = _f[0], setVerifyOtp = _f[1];
    var dispatch = useAppDispatch();
    var MobileNoRegex = getLocalStorageItem(LOCAL_STORAGE_KEYS.MOBILE_NO_REGEX);
    var regMob = MobileNoRegex ? MobileNoRegex : DEFAULT_MOB_NO_REGEX;
    regMob = new RegExp(regMob);
    var validate = function () {
        var fieldValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : values;
        var temp = _objectSpread({}, errors);
        if ("MobileNumber" in fieldValues)
            temp.MobileNumber = fieldValues.MobileNumber ? validateContactNumber(fieldValues.MobileNumber, 10) ? t("Enter valid mobile no.") : "" : "";
        if ("otp" in fieldValues)
            temp.otp = fieldValues.otp ? fieldValues.otp.length < 4 ? t("Enter valid OTP.") : "" : "";
        setErrors(_objectSpread({}, temp));
        if (fieldValues === values)
            return Object.values(temp).every(function (it) { return it === ""; });
    };
    var _g = MuiUseForm(initialValues, true, validate), values = _g.values, errors = _g.errors, setErrors = _g.setErrors, setValues = _g.setValues;
    useEffect(function () {
        var timer;
        if (isCounterActive && counter > 0) {
            timer = setInterval(function () {
                setCounter(function (prevCounter) { return prevCounter - 1; });
            }, 1000);
            dispatch(setReducerState({
                key: 'isTimerActive',
                value: true
            }));
        }
        else {
            dispatch(setReducerState({
                key: 'isTimerActive',
                value: false
            }));
        }
        return function () { return clearInterval(timer); };
    }, [isCounterActive, counter]);
    useEffect(function () {
        if (Primary) {
            onMobileNumberChange(Primary);
            setValues(_objectSpread(_objectSpread({}, values), {}, {
                MobileNumber: Primary !== null && Primary !== void 0 ? Primary : ''
            }));
        }
        if (Alternate) {
            onAlternateMobileNumberChange(Alternate);
            setValues(_objectSpread(_objectSpread({}, values), {}, {
                MobileNumber: Alternate !== null && Alternate !== void 0 ? Alternate : ''
            }));
        }
        if (!regMob.test(Primary)) {
            setPrimaryDisable(false);
        }
    }, [Primary, Alternate]);
    var handleChangeMobileNo = function (e) {
        var _a, _b;
        var _updatedValue;
        var _c = e.target, name = _c.name, value = _c.value;
        var updatedValue = value.replace(REG.nonNumericNumber, "");
        updatedValue = updatedValue.slice(0, 10);
        e.target.value = updatedValue;
        setValues(_objectSpread(_objectSpread({}, values), {}, (_a = {},
            _a[name] = updatedValue,
            _a)));
        if (updatedValue === '' || updatedValue.length > 0) {
            validate((_b = {},
                _b[name] = updatedValue,
                _b));
        }
        setCounter(timerCount);
        setIsCounterActive(false);
        setVerifyOtp(false);
        setValidationMessage === null || setValidationMessage === void 0 || setValidationMessage(true);
        if (onMobileNumberChange) {
            onMobileNumberChange(updatedValue);
        }
        if (onAlternateMobileNumberChange) {
            onAlternateMobileNumberChange(updatedValue);
            if (Alternate !== updatedValue) {
                setVerificationTickAlternate(false);
                setIsRiderVerified(false);
                setCounter(timerCount);
                setVerifyOtp(false);
                setSendOTP(true);
            }
        }
        if (updatedValue === Alternate) {
            setVerificationTickAlternate(true);
        }
        if (((_updatedValue = updatedValue) === null || _updatedValue === void 0 ? void 0 : _updatedValue.length) < 10) {
            if (setVerificationTickPrimary) {
                setVerificationTickPrimary(false);
            }
            if (isAlternateNumber) {
                if (setVerificationTickAlternate) {
                    setVerificationTickAlternate(false);
                }
            }
        }
    };
    var getOtp = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, otpResponse, _otpResponse$payload, _otpResponse$payload2, profileData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    request = {
                        MobileNumber: values.MobileNumber,
                        ModelName: vehicleDetail && vehicleDetail[0] && vehicleDetail[0].ProductName ? vehicleDetail[0].ProductName : "",
                        RegNo: vehicleDetail && vehicleDetail[0] && vehicleDetail[0].RegistrationNo ? vehicleDetail[0].RegistrationNo : ""
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: 'getOtpNum',
                            url: "".concat(sentOtpUrl),
                            request: request
                        }))];
                case 1:
                    otpResponse = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (otpResponse.payload.value.statusCode === 200) {
                        setVerifyOtp(true);
                        setValidationMessage === null || setValidationMessage === void 0 || setValidationMessage(true);
                        setIsCounterActive(true);
                        setCounter(timerCount);
                        setSendOTP(false);
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("OTP sent successfully"),
                            type: "success"
                        }));
                    }
                    else {
                        profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', handleServerSideErrorsForAnalytics(otpResponse === null || otpResponse === void 0 || (_otpResponse$payload = otpResponse.payload) === null || _otpResponse$payload === void 0 ? void 0 : _otpResponse$payload.value, sentOtpUrl, request));
                        dispatch(showNotification({
                            isOpen: true,
                            message: handleServerSideErrors(otpResponse === null || otpResponse === void 0 || (_otpResponse$payload2 = otpResponse.payload) === null || _otpResponse$payload2 === void 0 ? void 0 : _otpResponse$payload2.value, sentOtpUrl, request),
                            type: "error"
                        }));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("-------", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }; // API call for send OTP 
    var sendOtp = function () {
        setValues(_objectSpread(_objectSpread({}, values), {}, {
            otp: ''
        }));
        getOtp();
    };
    var onChangeOTP = function (event) {
        var _a, _b;
        var updatedValue = event.target.value;
        updatedValue = updatedValue.replace(REG.nonNumericNumber, '');
        updatedValue = updatedValue.slice(0, otpLength);
        event.target.value = updatedValue;
        var name = event.target.name;
        setValues(_objectSpread(_objectSpread({}, values), {}, (_a = {},
            _a[name] = updatedValue,
            _a)));
        validate((_b = {},
            _b[name] = updatedValue,
            _b));
    };
    var verifyOtpNum = function (e, otpOption) { return __awaiter(void 0, void 0, void 0, function () {
        var _verifyotpResponse$pa, request, verifyotpResponse, _verifyotpResponse$pa2, _verifyotpResponse$pa3, profileData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        MobileNumber: values.MobileNumber,
                        VerificationCode: values.otp
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: 'verifyOtp',
                            url: "".concat(verifyOtpUrl),
                            request: request
                        }))];
                case 1:
                    verifyotpResponse = _a.sent();
                    if (verifyotpResponse !== null && verifyotpResponse !== void 0 && (_verifyotpResponse$pa = verifyotpResponse.payload) !== null && _verifyotpResponse$pa !== void 0 && (_verifyotpResponse$pa = _verifyotpResponse$pa.value) !== null && _verifyotpResponse$pa !== void 0 && _verifyotpResponse$pa.success) {
                        setVerifyOtp(false);
                        setValidationMessage === null || setValidationMessage === void 0 || setValidationMessage(false);
                        setIsRiderVerified(true);
                        setCounter(timerCount);
                        setIsCounterActive(false);
                        if (isAlternateNumber && setVerificationTickAlternate) {
                            setVerificationTickAlternate(true);
                        }
                        if (setVerificationTickPrimary) {
                            setVerificationTickPrimary(true);
                        }
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("Mobile number verified"),
                            type: "success"
                        }));
                    }
                    else {
                        profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', handleServerSideErrorsForAnalytics(verifyotpResponse === null || verifyotpResponse === void 0 || (_verifyotpResponse$pa2 = verifyotpResponse.payload) === null || _verifyotpResponse$pa2 === void 0 ? void 0 : _verifyotpResponse$pa2.value, verifyOtpUrl, request));
                        dispatch(showNotification({
                            isOpen: true,
                            message: handleServerSideErrors(verifyotpResponse === null || verifyotpResponse === void 0 || (_verifyotpResponse$pa3 = verifyotpResponse.payload) === null || _verifyotpResponse$pa3 === void 0 ? void 0 : _verifyotpResponse$pa3.value, verifyOtpUrl, request),
                            type: "error"
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); }; // API call for OTP verfication
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(InputBox, {
        id: isAlternateNumber ? 'rider-mobileNo-input-alternate' : 'rider-mobileNo-input-primary',
        placeholder: t("Enter mobile no."),
        size: "small",
        fullWidth: true
        // value={(isAlternateNumber ? Alternate : Primary) ?? values.MobileNumber}
        ,
        value: (_values$MobileNumber = values.MobileNumber) !== null && _values$MobileNumber !== void 0 ? _values$MobileNumber : '',
        name: "MobileNumber",
        onChange: handleChangeMobileNo,
        error: errors === null || errors === void 0 ? void 0 : errors.MobileNumber,
        inputProps: {
            inputMode: 'numeric',
            pattern: '[0-9]*'
        },
        disabled: disabled || isPrimaryDisable,
        InputProps: {
            endAdornment: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Divider, {
                sx: {
                    height: 38,
                    m: 0
                },
                orientation: "vertical"
            }), !isRiderVerified && !verifyOtp && !verficationTickPrimary && !verficationTickAlternate || sendOTP ? /*#__PURE__*/ React.createElement(InputAdornment, {
                position: "end",
                style: {
                    width: '100px',
                    display: 'flex',
                    alignItems: 'center'
                }
            }, /*#__PURE__*/ React.createElement(MuiButton, {
                id: isAlternateNumber ? 'send-otp-btn-alternate' : "send-otp-btn-primary",
                name: t("Send OTP"),
                variant: "text",
                size: "medium",
                onClick: sendOtp,
                disabled: disabled || !(values !== null && values !== void 0 && values.MobileNumber) || (values === null || values === void 0 || (_values$MobileNumber2 = values.MobileNumber) === null || _values$MobileNumber2 === void 0 ? void 0 : _values$MobileNumber2.length) !== 10 || (values === null || values === void 0 ? void 0 : values.MobileNumber.charAt(0)) === '0' || !regMob.test(values === null || values === void 0 ? void 0 : values.MobileNumber)
            })) : isRiderVerified || verficationTickPrimary || verficationTickAlternate ? /*#__PURE__*/ React.createElement(InputAdornment, {
                position: "end",
                style: {
                    width: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }
            }, /*#__PURE__*/ React.createElement("img", {
                src: GreenVerifiedTick,
                alt: "succesicon",
                id: isAlternateNumber ? 'verified-img-alternate' : "verified-img-primary"
            })) : /*#__PURE__*/ React.createElement("div", null, counter <= 0 ? /*#__PURE__*/ React.createElement(InputAdornment, {
                position: "end",
                style: {
                    width: '100px',
                    display: 'flex',
                    alignItems: 'center'
                }
            }, /*#__PURE__*/ React.createElement(MuiButton, {
                id: "resend-otp-btn",
                name: t("Resend OTP"),
                variant: "text",
                size: "medium",
                onClick: sendOtp,
                disabled: !(values !== null && values !== void 0 && values.MobileNumber && !["0"].includes(values === null || values === void 0 ? void 0 : values.MobileNumber.charAt(0)))
            })) : /*#__PURE__*/ React.createElement("div", {
                style: {
                    width: '60px'
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h3",
                id: "otp-counter",
                align: "center",
                color: blue
            }, formatTime(counter)))))
        }
    }), verifyOtp && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(InputLabel, {
        sx: {
            '&.MuiInputLabel-root': {
                '&::after': {
                    content: '"*"',
                    color: 'red',
                    marginLeft: '2px'
                }
            }
        }
    }, t('OTP')), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(InputBox, {
        id: "otp-input",
        placeholder: t("Enter received OTP"),
        fullWidth: true,
        size: "small",
        value: values === null || values === void 0 ? void 0 : values.otp,
        name: "otp",
        onChange: onChangeOTP,
        error: errors === null || errors === void 0 ? void 0 : errors.otp,
        disabled: disabled || !verifyOtp,
        inputProps: {
            inputMode: 'numeric',
            pattern: '[0-9]*'
        },
        InputProps: (values === null || values === void 0 ? void 0 : values.otp) && (values === null || values === void 0 ? void 0 : values.otp.length) === parseInt(otpLength) && {
            endAdornment: /*#__PURE__*/ React.createElement(MuiButton, {
                name: t("Confirm"),
                variant: "text",
                id: "onConfirmClick",
                onClick: function (e) { return verifyOtpNum(e, 'otp'); }
            })
        }
    }))));
};
